import { JSONContent } from '@tiptap/core';
import { z } from 'zod';
import { validateJSONContent } from '../tip-tap';

export const TipTapContentSchemaRequired = z.custom<JSONContent>().superRefine((value, ctx) => {
  try {
    validateJSONContent(value);
  } catch {
    ctx.addIssue({
      code: 'custom',
      message: `Invalid TipTap JSON content: ${JSON.stringify(value)}`,
      fatal: true,
    });
    return z.NEVER;
  }
});
export type TipTapContentRequired = z.infer<typeof TipTapContentSchemaRequired>;

export const TipTapContentSchema = TipTapContentSchemaRequired.optional();
export type TipTapContent = z.infer<typeof TipTapContentSchema>;
